import format from 'date-fns/format'

import { isValid } from 'utils/dateUtils'

import {
  FillAdvancedFacebook,
  FillAdvancedGithub,
  FillAdvancedLinkedin,
  FillAdvancedTwitter,
  Global,
} from 'components/lib/DesignSystem/Icons'

export const SOURCE_KIND_ORDER = ['github', 'linkedin', 'facebook', 'twitter', 'web']

export const SOURCE_ICON_BY_KIND = {
  github: FillAdvancedGithub,
  linkedin: FillAdvancedLinkedin,
  facebook: FillAdvancedFacebook,
  twitter: FillAdvancedTwitter,
  web: Global,
}

const SOURCE_LABEL_BY_KIND = {
  github: 'GitHub post',
  linkedin: 'LinkedIn post',
  facebook: 'Facebook post',
  twitter: 'X post',
}

export const normalizeSourceKind = (kind = '') => {
  const normalizedKind = kind.toLowerCase()

  if (normalizedKind.includes('github')) {
    return 'github'
  }

  if (normalizedKind.includes('linkedin')) {
    return 'linkedin'
  }

  if (normalizedKind.includes('facebook')) {
    return 'facebook'
  }

  if (
    normalizedKind.includes('twitter') ||
    normalizedKind === 'x' ||
    normalizedKind.includes('x.com')
  ) {
    return 'twitter'
  }

  return 'web'
}

export const getSourcesByKind = (sources = []) =>
  sources.reduce(
    (acc, source) => {
      const kind = normalizeSourceKind(source.kind)

      acc[kind].push(source)

      return acc
    },
    {
      github: [],
      linkedin: [],
      facebook: [],
      twitter: [],
      web: [],
    }
  )

export const getSourceLabel = (source) => {
  const kind = normalizeSourceKind(source.kind)

  if (kind === 'web') {
    try {
      return new URL(source.url).hostname.replace(/^www\./, '')
    } catch {
      return 'Web link'
    }
  }

  return SOURCE_LABEL_BY_KIND[kind] || `${kind} post`
}

export const openSourceUrl = (event, url) => {
  event.stopPropagation()

  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

export const formatSuggestedSimulationTimestamp = (dateString) => {
  if (!dateString) {
    return { label: 'Date unavailable', unavailable: true }
  }

  const parsedDate = new Date(dateString)

  if (!isValid(parsedDate)) {
    return { label: 'Date unavailable', unavailable: true }
  }

  const label = `${format(parsedDate, 'MMM d, yyyy')} · ${format(parsedDate, 'h:mm a')}`
  const timezoneAbbreviation = Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
    .formatToParts(parsedDate)
    .find((part) => part.type === 'timeZoneName')?.value

  return {
    label,
    title: timezoneAbbreviation || Intl.DateTimeFormat().resolvedOptions().timeZone,
    unavailable: false,
  }
}
